import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BannerImg from "../../../images/locationgcc/sa/Ksablack-1.webp";

function whychoose({ rtl }) {
  const className = rtl ? "whychoose p-100 rtl-style" : "whychoose  p-100";
  return (
    <div className={className} style={{ backgroundImage: `url(${BannerImg})` }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={8} xxl={8}>
            <div className="choose-main">
              <div className="choose-box">
                <div className="choose-num">
                  300+<span>التطبيقات المطورة</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  65+<span>مراجعة</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  35+<span>الصناعات المخدومة</span>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={10} xl={10} xxl={10}>
            <h2>
              تجربة التميز مع TekRevol - لماذا تختارنا لبناء الحلول الرقمية؟
            </h2>
            <p>
              في TekRevol، لدينا فريق ضخم من المطورين والمصممين والمسوقين المهرة
              الذين لديهم إيمان إيجابي بفلسفة الفوضى المنظمة والجماعية الفردية.
              نحن نقدم خدمات وحلول رقمية استثنائية لسوق دول مجلس التعاون الخليجي
              على المدى الطويل. نقوم حاليًا بتوسيع أعمالنا في سوق المملكة
              العربية السعودية في مجالات الرعاية الصحية والخدمات اللوجستية
              والحلول حسب الطلب وتجارة التجزئة والسيارات والمزيد. يسعى المتخصصون
              الموهوبون لدينا بلا توقف إلى تقديم خدمات غير عادية لتطوير
              التطبيقات، واستشارات المؤسسات، وخدمات وحلول الأعمال الجاهزة للسوق.
            </p>
            <p>
              بمساعدة شركة تطوير تطبيقات الهاتف المحمول في الرياض، يمكنك إطلاق
              العنان لإمكانات عملك والوصول إلى آفاق جديدة من النجاح في أسرع وقت
              ممكن. أقرأ أقل
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default whychoose;
